/**
 * 手机区号
 */
import { OptionType } from '@/types';
export const PHONE_CODE_CONST: OptionType[] = [
  {
    label: '中国',
    value: '86',
  },
  {
    label: '中国香港',
    value: '852',
  },
  {
    label: '中国澳门',
    value: '853',
  },
  {
    label: '中国台湾',
    value: '886',
  },
  {
    label: '美国',
    value: '1',
  },
  {
    label: '加拿大',
    value: '1',
  },
  {
    label: '日本',
    value: '81',
  },
  {
    label: '韩国',
    value: '82',
  },
  {
    label: '新加坡',
    value: '65',
  },
  {
    label: '马来西亚',
    value: '60',
  },
  {
    label: '泰国',
    value: '66',
  },
  {
    label: '越南',
    value: '84',
  },
  {
    label: '菲律宾',
    value: '63',
  },
  {
    label: '印度尼西亚',
    value: '62',
  },
  {
    label: '澳大利亚',
    value: '61',
  },
  {
    label: '新西兰',
    value: '64',
  },
  {
    label: '英国',
    value: '44',
  },
  {
    label: '法国',
    value: '33',
  },
  {
    label: '德国',
    value: '49',
  },
  {
    label: '意大利',
    value: '39',
  },
  {
    label: '荷兰',
    value: '31',
  },
  {
    label: '比利时',
    value: '32',
  },
  {
    label: '西班牙',
    value: '34',
  },
  {
    label: '希腊',
    value: '30',
  },
  {
    label: '瑞士',
    value: '41',
  },
  {
    label: '瑞典',
    value: '46',
  },
  {
    label: '挪威',
    value: '47',
  },
  {
    label: '芬兰',
    value: '358',
  },
  {
    label: '丹麦',
    value: '45',
  },
  {
    label: '波兰',
    value: '48',
  },
  {
    label: '奥地利',
    value: '43',
  },
  {
    label: '匈牙利',
    value: '36',
  },
  {
    label: '捷克',
    value: '420',
  },
  {
    label: '斯洛伐克',
    value: '421',
  },
  {
    label: '克罗地亚',
    value: '385',
  },
  {
    label: '保加利亚',
    value: '359',
  },
  {
    label: '罗马尼亚',
    value: '40',
  },
  {
    label: '葡萄牙',
    value: '351',
  },
  {
    label: '爱尔兰',
    value: '353',
  },
  {
    label: '冰岛',
    value: '354',
  },
  {
    label: '立陶宛',
    value: '370',
  },
  {
    label: '拉脱维亚',
    value: '371',
  },
  {
    label: '爱沙尼亚',
    value: '372',
  },
  {
    label: '摩尔多瓦',
    value: '373',
  },
  {
    label: '亚美尼亚',
    value: '374',
  },

  {
    label: '乌克兰',
    value: '380',
  },
  {
    label: '白俄罗斯',
    value: '375',
  },
  {
    label: '摩纳哥',
    value: '377',
  },
  {
    label: '圣马力诺',
    value: '378',
  },
  {
    label: '安道尔',
    value: '376',
  },
  {
    label: '摩洛哥',
    value: '212',
  },
  {
    label: '阿尔及利亚',
    value: '213',
  },
  {
    label: '突尼斯',
    value: '216',
  },
  {
    label: '利比亚',
    value: '218',
  },
  {
    label: '冈比亚',
    value: '220',
  },
  {
    label: '塞内加尔',
    value: '221',
  },
  {
    label: '毛里塔尼亚',
    value: '222',
  },
  {
    label: '马里',
    value: '223',
  },
  {
    label: '几内亚',
    value: '224',
  },
  {
    label: '科特迪瓦',
    value: '225',
  },
  {
    label: '布基纳法索',
    value: '226',
  },
  {
    label: '尼日尔',
    value: '227',
  },
  {
    label: '多哥',
    value: '228',
  },

  {
    label: '贝宁',
    value: '229',
  },
  {
    label: '毛里求斯',
    value: '230',
  },
  {
    label: '利比里亚',
    value: '231',
  },
  {
    label: '塞拉利昂',
    value: '232',
  },
  {
    label: '加纳',
    value: '233',
  },
  {
    label: '尼日利亚',
    value: '234',
  },
  {
    label: '乍得',
    value: '235',
  },
  {
    label: '中非',
    value: '236',
  },
  {
    label: '喀麦隆',
    value: '237',
  },
  {
    label: '佛得角',
    value: '238',
  },
  {
    label: '圣多美和普林西比',
    value: '239',
  },
  {
    label: '赤道几内亚',
    value: '240',
  },
  {
    label: '加蓬',
    value: '241',
  },
  {
    label: '刚果',
    value: '242',
  },
  {
    label: '扎伊尔',
    value: '243',
  },
  {
    label: '安哥拉',
    value: '244',
  },
  {
    label: '几内亚比绍',
    value: '245',
  },
  {
    label: '塞舌尔',
    value: '248',
  },
  {
    label: '苏丹',
    value: '249',
  },
  {
    label: '卢旺达',
    value: '250',
  },
  {
    label: '埃塞俄比亚',
    value: '251',
  },
  {
    label: '索马里',
    value: '252',
  },
  {
    label: '吉布提',
    value: '253',
  },
  {
    label: '肯尼亚',
    value: '254',
  },

  {
    label: '坦桑尼亚',
    value: '255',
  },
  {
    label: '乌干达',
    value: '256',
  },
  {
    label: '布隆迪',
    value: '257',
  },
  {
    label: '莫桑比克',
    value: '258',
  },
  {
    label: '赞比亚',
    value: '260',
  },
  {
    label: '马达加斯加',
    value: '261',
  },
  {
    label: '留尼汪岛',
    value: '262',
  },
  {
    label: '津巴布韦',
    value: '263',
  },
  {
    label: '纳米比亚',
    value: '264',
  },
  {
    label: '马拉维',
    value: '265',
  },
  {
    label: '莱索托',
    value: '266',
  },
  {
    label: '博茨瓦纳',
    value: '267',
  },
  {
    label: '斯威士兰',
    value: '268',
  },
  {
    label: '科摩罗',
    value: '269',
  },
  {
    label: '马约特岛',
    value: '269',
  },
  {
    label: '南非',
    value: '27',
  },
  {
    label: '卢森堡',
    value: '352',
  },
];
